import { render, staticRenderFns } from "./CargoCarriersInput.vue?vue&type=template&id=d8c23a6a&scoped=true&"
import script from "./CargoCarriersInput.vue?vue&type=script&lang=js&"
export * from "./CargoCarriersInput.vue?vue&type=script&lang=js&"
import style0 from "./CargoCarriersInput.vue?vue&type=style&index=0&id=d8c23a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c23a6a",
  null
  
)

/* custom blocks */
import block0 from "./CargoCarriersInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports